import React from 'react'
import css from './styles.scss'
import globalCss from '../../../scss/global.scss'
import { connect } from 'react-redux'
import { editVariable, editingInstance } from '../../actions/actions'
import uuidv4 from 'uuid/v4'

export const MacroLink = function ({ varName, changesMade, instanceKey, modal, dragStart, type, dispatch, isDraggable, dragHandleProps, inListing, app: { secondaryColor }, variables: { editMode }, item: { varNameMap, invalidVariables, variables } }) {
  const readableName = varNameMap[varName]
  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
  const identifier = uuidv4()
  const invalid = invalidVariables || []
  let delFromField = null
  let dragHandle = null

  const openVarEditor = evt => {
    evt.preventDefault()
    dispatch(editVariable(varName))
    dispatch(editingInstance(instanceKey))
  }
  const removeFromEditField = evt => {
    evt.stopPropagation()
    const node = document.querySelector(`[data-identifier='${identifier}']`)
    if (node) {
      node.remove()
    }
    this.props.dispatch(changesMade())
  }
  if (isDraggable) {
    dragHandle = (
      <span className={`${css.handle} ${!editMode ? css.notEditing : ''}`} {...dragHandleProps}>
        <div className={css.bars} data-bars />
      </span>
    )
  }
  if (isFirefox) {
    delFromField = (
      <button onClick={removeFromEditField} type='button' className={css.remove}>
        <i className={globalCss.iconX} />
      </button>
    )
  }

  let notDraggable = null
  if (type === 'choiceFromDataSource') {
    notDraggable = css.notDraggable
  }

  let hasInstanceModifiers = false
  if (instanceKey && variables[varName] && variables[varName].instances) {
    const instances = variables[varName].instances[instanceKey]
    if (instances && instances.length) {
      hasInstanceModifiers = true
    }
  }

  const link = (
    <a
      href='#'
      contentEditable='false'
      suppressContentEditableWarning
      draggable={(notDraggable || modal) ? 'false' : 'true'}
      data-macro-type={type}
      data-identifier={identifier}
      data-variable-name={varName}
      data-instance={instanceKey}
      data-modal='edit'
      onDragStart={dragStart}
      onClick={openVarEditor}
      className={!invalid.includes(varName) ? `${css.MacroLink} ${notDraggable}` : `${css.MacroLinkError} ${notDraggable}`}
      style={{ borderColor: secondaryColor, color: secondaryColor, borderStyle: hasInstanceModifiers ? 'dashed' : (type === 'choiceFromDataSource' ? 'none' : 'solid') }}
    >{dragHandle}{readableName}&nbsp;
      <i className={globalCss.iconEditCircle} style={{ visibility: notDraggable ? 'hidden' : 'visible' }} /> {delFromField}
    </a>
  )
  if (editMode) {
    return (
      <span>
        {link}
      </span>
    )
  }
  if (inListing) {
    return (
      <span>
        {link}
      </span>
    )
  }
  return link
}
const mapStateToProps = state => {
  const { app, variables, item } = state
  return {
    app,
    variables,
    item
  }
}
export default connect(mapStateToProps)(MacroLink)



// WEBPACK FOOTER //
// /app/js/components/MacroLink/index.js